import { useEffect, useRef, useState } from 'react';
import useAdminDraftGuard from './useAdminDraftGuard';

// Confirmation owns a snapshot; a replaced account/search/tab session cannot
// apply late mutation results to its successor. Already sent requests may finish.
export default function useAdminBulkAction(onSuccess) {
  const [confirmation, setConfirmation] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const alive = useRef(true);
  useAdminDraftGuard(null, { busy });
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  const close = () => {
    if (!pending.current) setConfirmation(null);
  };
  const open = (ids, detail = {}) => {
    if (pending.current || !ids.length) return;
    setError('');
    setConfirmation({ ...detail, ids: [...ids] });
  };
  const run = async (request) => {
    if (pending.current || !confirmation?.ids.length) return;
    pending.current = true;
    setBusy(true);
    setError('');
    try {
      await request(confirmation.ids);
      if (!alive.current) return;
      setConfirmation(null);
      onSuccess();
    } catch (_error) {
      if (alive.current)
        setError('변경하지 못했습니다. 선택한 대상과 입력을 확인한 뒤 다시 시도해주세요.');
    } finally {
      pending.current = false;
      if (alive.current) setBusy(false);
    }
  };
  return { confirmation, busy, error, open, close, run };
}
